import TopLogout from "../components/TopLogout";
import React, { useEffect, useState } from "react";
import BottomNav from "../components/BottomNav";

/* 🔴 Firebase REMOVED COMPLETELY */

export default function Dashboard() {
  const [data, setData] = useState({
    tds: 0,
    ph: 0,
    npk: 0,
    temp: 0,
    humidity: 0,
    light: 0,
    online: false,
    lastUpdated: "—",
  });

  const formatTime = (ts) => {
    if (!ts) return "—";
    return ts;
  };

  /* ✅ FETCH DATA + ONLINE/OFFLINE LOGIC (15 sec) */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://laturelectronics.in/smartagri_api/get_latest.php"
        );
        const json = await res.json();

        if (json && json.id) {
          // ⏱ TIME CHECK (15 seconds)
          const lastTime = new Date(json.created_at.replace(" ", "T"));
          const now = new Date();
          const diffSeconds = (now - lastTime) / 1000;

          const isOnline = diffSeconds <= 15;

          setData({
            tds: Number(json.tds),
            ph: Number(json.ph),
            npk:
              Number(json.nitrogen) +
              Number(json.phosphorus) +
              Number(json.potassium),
            temp: Number(json.temperature),
            humidity: Number(json.humidity),
            light: Number(json.light),
            online: isOnline,
            lastUpdated: json.created_at,
          });
        } else {
          setData((prev) => ({ ...prev, online: false }));
        }
      } catch (err) {
        console.error(err);
        setData((prev) => ({ ...prev, online: false }));
      }
    };

    fetchData(); // first load
    const interval = setInterval(fetchData, 5000); // every 5 sec

    return () => clearInterval(interval);
  }, []);

  const MAX = {
    tds: 2000,
    ph: 14,
    npk: 1000,
    temp: 50,
    humidity: 100,
    light: 2000,
  };

  const getOffset = (value, max) => {
    const r = 45;
    const circ = 2 * Math.PI * r;
    if (value === null || value === undefined) return circ;
    const percent = Math.min(100, (value / max) * 100);
    return circ - (percent / 100) * circ;
  };

  return (
    <div style={styles.bg}>
      <img src="/com_logo.png" alt="Company Logo" style={styles.companyLogo} />

      <div style={styles.overlay}>
        <TopLogout />
        <h1 style={styles.title}>Dashboard</h1>
        <p style={styles.subtitle}>
          Live monitoring of all hydroponic & smart agriculture parameters.
        </p>

        <div style={styles.statusCard}>
          <h3 style={styles.statusText}>
            Device Status:{" "}
            <span style={{ color: data.online ? "#00e676" : "#ff5252" }}>
              {data.online ? "Online" : "Offline"}
            </span>
          </h3>
          <p>Last updated: {formatTime(data.lastUpdated)}</p>
        </div>

        <div style={styles.grid}>
          {[
            { label: "TDS", value: `${data.tds} ppm`, key: "tds", color: "#00e676" },
            { label: "pH", value: data.ph, key: "ph", color: "#00b0ff" },
            { label: "NPK", value: data.npk, key: "npk", color: "#ffa726" },
            { label: "Temperature", value: `${data.temp}°C`, key: "temp", color: "#ff5252" },
            { label: "Humidity", value: `${data.humidity}%`, key: "humidity", color: "#40c4ff" },
            { label: "Light", value: data.light, key: "light", color: "#ffd740" },
          ].map((item) => (
            <div style={styles.card} className="hover-card" key={item.key}>
              <h3>{item.label}</h3>
              <div style={styles.circleContainer}>
                <svg width="110" height="110">
                  <circle cx="55" cy="55" r="45" stroke="#555" strokeWidth="6" fill="none" />
                  <circle
                    cx="55"
                    cy="55"
                    r="45"
                    stroke={item.color}
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray={2 * Math.PI * 45}
                    strokeDashoffset={getOffset(data[item.key], MAX[item.key])}
                  />
                </svg>
                <span style={styles.circleValue}>{item.value}</span>
              </div>
            </div>
          ))}
        </div>

        <div style={styles.notifCard}>
          <h3>Notifications</h3>
          <p>{data.temp > 30 ? "High Temperature Alert" : "No alerts"}</p>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}

/* ---------- STYLES (UNCHANGED) ---------- */
const styles = {
  bg: {
    backgroundImage: "url('/bg3.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    width: "100%",
  },
  companyLogo: {
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "140px",
    zIndex: 1000,
  },
  overlay: {
    background: "rgba(0,0,0,0.55)",
    minHeight: "100vh",
    padding: "20px",
    paddingBottom: "90px",
    textAlign: "center",
    color: "white",
  },
  title: { fontSize: "32px", fontWeight: "bold", color: "#a8ff60" },
  subtitle: { fontSize: "16px", marginBottom: "25px", color: "#d3ffd1" },
  statusCard: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: "14px",
    padding: "15px",
    marginBottom: "20px",
  },
  statusText: { fontSize: "18px", fontWeight: "600" },
  grid: { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "18px" },
  card: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: "14px",
    padding: "18px",
  },
  circleContainer: {
    position: "relative",
    width: "110px",
    height: "110px",
    margin: "auto",
  },
  circleValue: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontWeight: "bold",
  },
  notifCard: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: "14px",
    padding: "18px",
    marginTop: "20px",
  },
};
